import {
  type Contentful,
  ContentStyle,
  type IconNameContent,
  type LinkContent,
} from '@/contentful/contentful-exports';

import ActionCards, {
  type ActionCard,
  type ActionCardsProps,
} from './ActionCards';

export interface ActionCardContent extends Contentful {
  fields: {
    iconName?: IconNameContent;
    heading?: string;
    subheading?: string;
    cta?: LinkContent;
  };
}

export interface ActionCardsContent extends Contentful {
  fields: {
    style?: ContentStyle;
    eyebrow?: string;
    heading?: string;
    subheading?: string;
    cards?: ActionCardContent[];
  };
}

interface ActionCardsgridProps {
  content: ActionCardsContent;
}

export default function ActionCardsWrapper({
  content: {
    fields: {
      style = ContentStyle.OnDark,
      eyebrow,
      heading,
      subheading,
      cards,
    },
  },
}: ActionCardsgridProps) {
  const fieldlessCards: ActionCard[] | undefined = cards?.map(
    ({
      fields: {
        iconName: iconNameContent,
        heading,
        subheading,
        cta: ctaContent,
      },
    }): ActionCard => {
      const iconName = iconNameContent?.fields?.name;
      const cta = ctaContent?.fields;

      return {
        ...(heading && { heading }),
        ...(subheading && { subheading }),
        ...(cta && { cta }),
        ...(iconName && { iconName }),
      };
    }
  );

  const props: ActionCardsProps = {
    ...(style && { style }),
    ...(eyebrow && { eyebrow }),
    ...(heading && { heading }),
    ...(subheading && { subheading }),
    ...(fieldlessCards && { cards: fieldlessCards }),
  };
  return <ActionCards {...props} />;
}
